import { useCallback, useEffect, useState } from 'react';
import { useLlcApi } from '../Api';
import { BusinessEntityDashboardDto } from '../types/businessEntities';

interface BusinessEntitiesState {
  entities: BusinessEntityDashboardDto[];
  loading: boolean;
  error: boolean;
}

export function useBusinessEntities(): BusinessEntitiesState {
  const llcApi = useLlcApi();
  const [state, setState] = useState<BusinessEntitiesState>({
    entities: [],
    loading: true,
    error: false,
  });

  const load = useCallback(
    async (signal: AbortSignal) => {
      setState((s) => ({ ...s, loading: true, error: false }));
      try {
        const response = await llcApi.get<BusinessEntityDashboardDto[]>(
          '/api/BusinessEntity/dashboard',
          { signal }
        );
        setState({
          entities: response.data ?? [],
          loading: false,
          error: false,
        });
      } catch {
        if (signal.aborted) return;
        setState({ entities: [], loading: false, error: true });
      }
    },
    [llcApi]
  );

  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return state;
}
